import { Typography } from "antd";
import usePageTitle from "../../services/usePageTitle";

export default function SkeyeStudio({ pageTitle = "Skeye Studio" }) {
  usePageTitle("SkeyeStudio - SkeyeGate™");

  return (
    <div className="skeye-studio-page">
      <Typography.Title level={2} className="page-title">
        {pageTitle}
      </Typography.Title>
      <Typography.Paragraph className="page-description">
        Skeye Studio is your creative hub for designing and customizing your
        Skeye experience. Here, you can create and manage your own themes,
        widgets, and layouts to make Skeye truly your own. Whether you're a
        designer or just want to personalize your interface, Skeye Studio
        provides the tools you need to bring your vision to life.
      </Typography.Paragraph>
    </div>
  );
}
